import { Ref, useEffect, useRef } from 'react';
import { useEditPipelineContext } from '../../hooks/useEditPipelineContext';
import {
  PipelineSettings,
  PipelineSettingsImperativeRef,
  PipelineSettingsInnerState
} from '../../../PipelineSettings/PipelineSettings';
import { WizardStepBaseProps } from '../../../../wizard/interfaces/wizard-step-base-props';
import { RawIntegration } from '../../../../shared/interfaces/integration';
import { IntegrationFactory } from '../../../factories/integrationFactory';

export function EditPipelineSettings({
  completeStep,
  updateWizardStepFooterProps
}: WizardStepBaseProps) {
  const { updatePipeline, pipeline } = useEditPipelineContext();

  const pipelineSettingsRef = useRef<PipelineSettingsImperativeRef>();

  useEffect(() => {
    return () => {
      updateWizardStepFooterProps({});
    };
  }, []);

  if (!pipeline) {
    return null;
  }

  const onSavePipeline = (rawIntegration: RawIntegration) => {
    const _pipeline = IntegrationFactory(rawIntegration);

    updatePipeline({
      ...pipeline,
      ..._pipeline
    });
    completeStep();
  };

  const onPipelineSettingsInnerStateUpdate = (state: PipelineSettingsInnerState) => {
    const disableContinue = state.savingPipeline || state.isValidating;

    updateWizardStepFooterProps({
      onClick: () => pipelineSettingsRef.current?.submitForm(),
      showProgress: disableContinue,
      disabled: disableContinue,
      children: 'Next'
    });
  };

  return (
    <PipelineSettings
      pipeline={pipeline}
      onSavePipeline={onSavePipeline}
      formImperativeRef={pipelineSettingsRef as unknown as Ref<PipelineSettingsImperativeRef>}
      onStateUpdate={onPipelineSettingsInnerStateUpdate}
      isEditing
    />
  );
}
